import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-user-header',
  imports: [RouterModule, MatButtonModule, MatIconModule],
  templateUrl: './user-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-header.component.scss',
})
export class UserHeaderComponent {}
